import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=f80321bc&scoped=true"
import script from "./BaseTooltip.vue?vue&type=script&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&lang=js"
import style0 from "./BaseTooltip.vue?vue&type=style&index=0&id=f80321bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80321bc",
  null
  
)

export default component.exports